export default () => ({
  showModal: false,
  showOrgModal: false,
  showModalDraft: false,
  showModalReply: false,
  modalData: {},
  replyPostData: {},
  quotePostData: {},
  showModalAboutUs: false,
});
